import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../styles/diario.scss'

const Concurso = (props) => {

    function getTitulo(conc) {
        // Checa se algum anexo contém "RESULTADO"
        const hasResultado = conc.anexos?.some(anexo => /RESULTADO/i.test(anexo.nomeAnexo));

        if (hasResultado) {
            return "Resultado Final Publicado em 10/05/2010 no Jornal O Macuco";
        } else if (conc.referencia) {
            return `Edital de Convocação nº ${conc.referencia}`;
        } else {
            return "Edital de Abertura do Concurso";
        }
    }
    function renderButtons(props) {
        const buttons = [];

        if (props.conc.anexos) {
            props.conc.anexos.forEach((anexo, index) => {
                buttons.push(
                    <Fragment key={`anexo-${index}`}>
                        <a href={anexo.arquivo} target="_blank" rel="noreferrer">
                            <Button type="button" variant="primary">{anexo.nomeAnexo}</Button>
                        </a>
                        <br />
                        <br />
                    </Fragment>
                );
            });
        }
        return buttons;
    }

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header>
                        <h5>{props.conc.tipoEdital} {props.conc.referencia ? `Nº ${props.conc.referencia}` : null} de {props.conc.anexos[0]?.ano || props.conc.ano}</h5>
                    </Card.Header>
                    <Card.Body>
                        {props.conc.orgao}<br /><br />
                        {renderButtons(props)}
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Concurso;